import {
  AlertTriangle, ArrowLeft, Banknote, BookOpen, ChevronDown, Coins, CreditCard, Medal,
  Package, Scale, Send, ShoppingCart, Smartphone, Wallet, Wrench
} from 'lucide-react';
import { stripBankAccountType, eTicaretCardLabel, isShopifySale } from '../utils/kasaOzeti';
import { formatPaymentMethod, getSaleDisplayAmount } from '../utils/saleDisplay';
import '../pages/RetailSales.css';

// Gün Sonu raporunun "Genel" sekmesi: özet kartları (tıklanınca detay sayfası), ödeme dağılımı,
// kasiyer raporu, hurda / tahsilat / tüm işlemler / tamirat tabloları. Web'deki Gün Sonu modalı
// (RetailSales) ve iOS admin uygulamasının WebView'da açtığı /mobile/gun-sonu sayfası (MobileGunSonu)
// aynı bileşeni kullanır. Açılır/kapanır durumlar dışarıdan verilir — web modalı açılışta sıfırlıyor.
const EndOfDayGenel = ({
  report: endOfDayReport,
  expandedPaymentType, setExpandedPaymentType,
  expandedCashiers, setExpandedCashiers,
  eodCashierFilter, setEodCashierFilter,
  expandedSales, setExpandedSales,
}) => (
    <>
      {/* Özet Kartları veya Detay Sayfası */}
      {expandedPaymentType ? (
        <div className="eod-detail-page">
          <button className="eod-detail-back-btn" onClick={() => setExpandedPaymentType(null)}>
            <ArrowLeft size={18} /> Geri Dön
          </button>
          <h3 className="eod-detail-title">
            {expandedPaymentType === 'ciro' && 'Toplam Ciro Detayı'}
            {expandedPaymentType === 'islem' && 'İşlem Detayları'}
            {expandedPaymentType === 'kasa' && 'Nakit Kasa Toplamı Detayı'}
            {expandedPaymentType === 'card' && 'Kart Çekim Detayı'}
            {expandedPaymentType === 'transfer' && 'Havale/EFT Detayı'}
            {expandedPaymentType === 'openAccount' && 'Açık Hesap Detayı'}
            {expandedPaymentType === 'sanalPos' && `${eTicaretCardLabel(endOfDayReport.sanalPos)} Detayı`}
            {expandedPaymentType === 'expenses' && 'Masraf Detayı'}
            {expandedPaymentType === 'scrap' && 'Hurda Alımı Detayı'}
          </h3>

          <div className="eod-detail-list">
            {/* Ciro */}
            {expandedPaymentType === 'ciro' && (<>
              {endOfDayReport.sales?.map((sale, idx) => {
              const scrapAmount = Number(sale.scrap_total_amount) || 0;
              const displayTotal = getSaleDisplayAmount(sale);
              return (
              <div key={sale.id || idx} className="eod-detail-row">
                <div className="detail-left">
                  <span className="detail-customer">{sale.customer_name || 'Müşteri'}</span>
                  <span className="detail-meta">#{sale.store_sale_number || sale.id} - {sale.payment_method || '-'}{scrapAmount > 0 ? ` (Hurda: ₺${scrapAmount.toLocaleString('tr-TR')})` : ''}</span>
                </div>
                <span className="detail-amount">₺{displayTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
              </div>
              );
              })}
              {endOfDayReport.exchanges?.items?.map((exc, idx) => (
                <div key={`exc-${exc.id || idx}`} className="eod-detail-row">
                  <div className="detail-left">
                    <span className="detail-customer">{exc.customer_name || 'Müşteri'}</span>
                    <span className="detail-meta">Değişim İade #{exc.id} - {exc.payment_method || '-'}</span>
                  </div>
                  <span className="detail-amount" style={{ color: '#dc2626' }}>-₺{Number(exc.return_total).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                </div>
              ))}
              {endOfDayReport.repairRevenue?.items?.map((repair, idx) => (
                <div key={`repair-${repair.id || idx}`} className="eod-detail-row">
                  <div className="detail-left">
                    <span className="detail-customer">🔧 {repair.customer_name || 'Müşteri'}</span>
                    <span className="detail-meta">Tamirat #{repair.repair_code} - {repair.payment_method || 'Nakit'}</span>
                  </div>
                  <span className="detail-amount" style={{ color: '#059669' }}>₺{Number(repair.payment_amount).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                </div>
              ))}
            </>)}

            {/* İşlem Sayısı */}
            {expandedPaymentType === 'islem' && (<>
              {endOfDayReport.sales?.map((sale, idx) => {
              const scrapAmount = Number(sale.scrap_total_amount) || 0;
              const displayTotal = getSaleDisplayAmount(sale);
              return (
              <div key={sale.id || idx} className="eod-detail-row">
                <div className="detail-left">
                  <span className="detail-customer">{sale.customer_name || 'Müşteri'}</span>
                  <span className="detail-meta">#{sale.store_sale_number || sale.id} - {sale.staff_name || '-'}{scrapAmount > 0 ? ` (Hurda: ₺${scrapAmount.toLocaleString('tr-TR')})` : ''}</span>
                </div>
                <span className="detail-amount">₺{displayTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
              </div>
              );
              })}
              {endOfDayReport.exchanges?.items?.map((exc, idx) => (
                <div key={`exc-${exc.id || idx}`} className="eod-detail-row">
                  <div className="detail-left">
                    <span className="detail-customer">{exc.customer_name || 'Müşteri'}</span>
                    <span className="detail-meta">Değişim İade #{exc.id} - {exc.staff_name || '-'}</span>
                  </div>
                  <span className="detail-amount" style={{ color: '#dc2626' }}>-₺{Number(exc.return_total).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                </div>
              ))}
              {endOfDayReport.repairRevenue?.items?.map((repair, idx) => (
                <div key={`repair-${repair.id || idx}`} className="eod-detail-row">
                  <div className="detail-left">
                    <span className="detail-customer">🔧 {repair.customer_name || 'Müşteri'}</span>
                    <span className="detail-meta">Tamirat #{repair.repair_code} - {repair.payment_method || 'Nakit'}</span>
                  </div>
                  <span className="detail-amount" style={{ color: '#059669' }}>₺{Number(repair.payment_amount).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                </div>
              ))}
            </>)}

            {/* Kasa */}
            {expandedPaymentType === 'kasa' && (() => {
              // Tüm nakit hareketlerini topla
              const kasaItems = [];

              // 1. Satışlardan nakit girişler
              endOfDayReport.sales?.filter(s => s.sale_type !== 'refund' && Number(s.total) >= 0).forEach(sale => {
                let details = null;
                try { details = typeof sale.payment_details === 'string' ? JSON.parse(sale.payment_details) : sale.payment_details; } catch(e) {}
                if (sale.payment_method === 'Nakit') {
                  kasaItems.push({ label: sale.customer_name || 'Müşteri', meta: `#${sale.store_sale_number || sale.id} - Nakit Satış`, amount: getSaleDisplayAmount(sale), type: 'income' });
                } else if (Array.isArray(details)) {
                  const nakitDetail = details.filter(d => d.method === 'Nakit');
                  nakitDetail.forEach(d => {
                    const amt = parseFloat(d.amount_tl || d.amountTL || d.amount) || 0;
                    if (amt > 0) kasaItems.push({ label: sale.customer_name || 'Müşteri', meta: `#${sale.store_sale_number || sale.id} - Karışık (Nakit kısmı)`, amount: amt, type: 'income' });
                  });
                }
              });

              // 2. İade satışlarından nakit çıkışlar
              endOfDayReport.sales?.filter(s => s.sale_type === 'refund' || Number(s.total) < 0).forEach(sale => {
                let details = null;
                try { details = typeof sale.payment_details === 'string' ? JSON.parse(sale.payment_details) : sale.payment_details; } catch(e) {}
                if (Array.isArray(details)) {
                  details.forEach(d => {
                    const methodLower = (d.method || '').toLowerCase();
                    if (methodLower.includes('nakit')) {
                      const amt = Math.abs(parseFloat(d.amount_tl || d.amountTL || d.amount) || 0);
                      if (amt > 0) kasaItems.push({ label: sale.customer_name || 'Müşteri', meta: `#${sale.store_sale_number || sale.id} - Nakit İade`, amount: -amt, type: 'expense' });
                    }
                  });
                } else if (sale.payment_method && sale.payment_method.toLowerCase().includes('nakit')) {
                  kasaItems.push({ label: sale.customer_name || 'Müşteri', meta: `#${sale.store_sale_number || sale.id} - Nakit İade`, amount: Number(sale.total), type: 'expense' });
                }
              });

              // 2b. Hurda ile nakit iade satışları (hurda > ürün değeri, müşteriye nakit verildi)
              endOfDayReport.sales?.filter(s => s.payment_method === 'Nakit İade' && s.sale_type !== 'refund').forEach(sale => {
                const scrapAmount = Number(sale.scrap_total_amount) || 0;
                const saleSubtotal = Number(sale.subtotal) || 0;
                const saleDiscountVal = Number(sale.discount) || 0;
                const netProductValue = saleSubtotal - saleDiscountVal;
                const cashRefundAmt = scrapAmount > netProductValue ? scrapAmount - netProductValue : 0;
                if (cashRefundAmt > 0) {
                  kasaItems.push({ label: sale.customer_name || 'Müşteri', meta: `#${sale.store_sale_number || sale.id} - Hurda Nakit İade`, amount: -cashRefundAmt, type: 'expense' });
                }
              });

              // 3. Nakit tahsilatlar
              endOfDayReport.collections?.items?.forEach(c => {
                const method = c.payment_method || 'Nakit';
                if (method.startsWith('Nakit')) {
                  kasaItems.push({ label: c.customer_name || 'Müşteri', meta: `Tahsilat - ${method}`, amount: parseFloat(c.amount) || 0, type: 'income' });
                } else if (method === 'Karışık') {
                  let details = null;
                  try { details = typeof c.payment_details === 'string' ? JSON.parse(c.payment_details) : c.payment_details; } catch(e) {}
                  if (Array.isArray(details)) {
                    details.filter(d => d.method === 'Nakit' || d.method?.startsWith('Nakit')).forEach(d => {
                      const amt = parseFloat(d.amount) || 0;
                      if (amt > 0) kasaItems.push({ label: c.customer_name || 'Müşteri', meta: 'Tahsilat - Karışık (Nakit kısmı)', amount: amt, type: 'income' });
                    });
                  }
                }
              });

              // 4. Nakit hurda ödemeleri (Tahsilat Mahsup hariç - tahsilat kasa hareketini etkilemez)
              endOfDayReport.scrap?.items?.forEach(scr => {
                if (scr.payment_method === 'Tahsilat Mahsup') return;
                if (!scr.payment_method || scr.payment_method === 'Nakit') {
                  kasaItems.push({ label: scr.customer_name || 'Müşteri', meta: `Hurda Alım - ${scr.metal_type === 'gold' ? 'Altın' : 'Gümüş'}`, amount: -(parseFloat(scr.total_amount) || 0), type: 'expense' });
                }
              });

              // 5. Hurda iade kasayı etkilemez (fiziksel hurda iadesi)

              // 6. Nakit masraflar
              endOfDayReport.expenses?.items?.filter(e => e.payment_method === 'Nakit').forEach(exp => {
                kasaItems.push({ label: exp.description || exp.category || 'Masraf', meta: `Masraf - ${exp.category || ''}`, amount: -(parseFloat(exp.amount) || 0), type: 'expense' });
              });

              // 7. Nakit değişim iadeleri
              endOfDayReport.exchanges?.items?.filter(e => e.payment_method === 'Nakit İade').forEach(exc => {
                kasaItems.push({ label: exc.customer_name || 'Müşteri', meta: `Değişim İade`, amount: -(Math.abs(parseFloat(exc.difference) || 0)), type: 'expense' });
              });

              // 8. Nakit tamirat gelirleri
              endOfDayReport.repairRevenue?.items?.forEach(repair => {
                let details = null;
                try { details = typeof repair.payment_details === 'string' ? JSON.parse(repair.payment_details) : repair.payment_details; } catch(e) {}
                if (Array.isArray(details)) {
                  details.filter(d => d.method === 'Nakit').forEach(d => {
                    const amt = parseFloat(d.amount) || 0;
                    if (amt > 0) kasaItems.push({ label: repair.customer_name || 'Müşteri', meta: `Tamirat #${repair.repair_code} - Nakit`, amount: amt, type: 'income' });
                  });
                } else if (repair.payment_method === 'Nakit') {
                  kasaItems.push({ label: repair.customer_name || 'Müşteri', meta: `Tamirat #${repair.repair_code} - Nakit`, amount: parseFloat(repair.payment_amount) || 0, type: 'income' });
                }
              });

              return (
              <>
                {kasaItems.length > 0 ? kasaItems.map((item, idx) => (
                  <div key={idx} className="eod-detail-row">
                    <div className="detail-left">
                      <span className="detail-customer">{item.label}</span>
                      <span className="detail-meta">{item.meta}</span>
                    </div>
                    <span className="detail-amount" style={{ color: item.amount >= 0 ? '#16a34a' : '#dc2626' }}>
                      {item.amount >= 0 ? '+' : ''}₺{item.amount.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}
                    </span>
                  </div>
                )) : (
                  <div className="eod-detail-row">
                    <span className="detail-customer" style={{ color: '#94a3b8' }}>Nakit hareket yok</span>
                  </div>
                )}
              </>
              );
            })()}

            {/* Kart */}
            {expandedPaymentType === 'card' && (
              <>
                {endOfDayReport.card.items?.map((sale, idx) => (
                  <div key={sale.id || idx} className="eod-detail-row">
                    <div className="detail-left">
                      <span className="detail-customer">{sale.customer_name || 'Müşteri'}</span>
                      <span className="detail-meta">#{sale.store_sale_number || sale.id}</span>
                    </div>
                    <span className="detail-amount">₺{getSaleDisplayAmount(sale).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                  </div>
                ))}
                {/* Karışık ödemelerin Kart kısmı */}
                {endOfDayReport.mixed?.items?.map((sale, idx) => {
                  let details = [];
                  try { details = typeof sale.payment_details === 'string' ? JSON.parse(sale.payment_details) : (sale.payment_details || []); } catch(e) {}
                  if (!Array.isArray(details)) return null;
                  const cardAmount = details.filter(d => d.method === 'Kredi Kartı').reduce((sum, d) => sum + (parseFloat(d.amount_tl || d.amountTL || d.amount) || 0), 0);
                  if (cardAmount <= 0) return null;
                  return (
                    <div key={`mixed-card-${sale.id || idx}`} className="eod-detail-row">
                      <div className="detail-left">
                        <span className="detail-customer">{sale.customer_name || 'Müşteri'}</span>
                        <span className="detail-meta">#{sale.store_sale_number || sale.id} • Karışık ödeme</span>
                      </div>
                      <span className="detail-amount">₺{cardAmount.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                    </div>
                  );
                })}
                {endOfDayReport.cardRefund?.items?.map((sale, idx) => (
                  <div key={`cr-${sale.id || idx}`} className="eod-detail-row">
                    <div className="detail-left">
                      <span className="detail-customer">{sale.customer_name || 'Müşteri'}</span>
                      <span className="detail-meta">#{sale.store_sale_number || sale.id} - Kredi Kartı İade</span>
                    </div>
                    <span className="detail-amount" style={{ color: '#dc2626' }}>-₺{Math.abs(Number(sale.total)).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                  </div>
                ))}
                {endOfDayReport.exchanges?.items?.filter(e => e.payment_method === 'Kredi Kartı İade').map((exc, idx) => (
                  <div key={`exc-cr-${exc.id || idx}`} className="eod-detail-row">
                    <div className="detail-left">
                      <span className="detail-customer">{exc.customer_name || 'Müşteri'}</span>
                      <span className="detail-meta">Değişim İade #{exc.id} - Kredi Kartı İade</span>
                    </div>
                    <span className="detail-amount" style={{ color: '#dc2626' }}>-₺{Math.abs(parseFloat(exc.difference) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                  </div>
                ))}
                {endOfDayReport.card.collectionTotal > 0 && (
                  <div className="eod-detail-row highlight-green">
                    <div className="detail-left"><span className="detail-customer">Kart ile Tahsilatlar</span></div>
                    <span className="detail-amount" style={{ color: '#16a34a' }}>+₺{endOfDayReport.card.collectionTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                  </div>
                )}
                {endOfDayReport.card.repairTotal > 0 && (
                  <div className="eod-detail-row highlight-green">
                    <div className="detail-left"><span className="detail-customer">🔧 Tamirat Geliri (Kart)</span></div>
                    <span className="detail-amount" style={{ color: '#059669' }}>+₺{endOfDayReport.card.repairTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                  </div>
                )}
              </>
            )}

            {/* Havale/EFT */}
            {expandedPaymentType === 'transfer' && (
              <>
                {endOfDayReport.transfer.items?.map((sale, idx) => (
                  <div key={sale.id || idx} className="eod-detail-row">
                    <div className="detail-left">
                      <span className="detail-customer">{sale.customer_name || 'Müşteri'}</span>
                      <span className="detail-meta">#{sale.store_sale_number || sale.id}</span>
                    </div>
                    <span className="detail-amount">₺{getSaleDisplayAmount(sale).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                  </div>
                ))}
                {/* Karışık ödemelerin Havale/EFT kısmı */}
                {endOfDayReport.mixed?.items?.map((sale, idx) => {
                  let details = [];
                  try { details = typeof sale.payment_details === 'string' ? JSON.parse(sale.payment_details) : (sale.payment_details || []); } catch(e) {}
                  if (!Array.isArray(details)) return null;
                  const transferDetails = details.filter(d => d.method === 'Havale/EFT');
                  const transferAmount = transferDetails.reduce((sum, d) => sum + (parseFloat(d.amount_tl || d.amountTL || d.amount) || 0), 0);
                  if (transferAmount <= 0) return null;
                  const bankAccount = stripBankAccountType(transferDetails[0]?.bank_account || transferDetails[0]?.bankAccount || '');
                  return (
                    <div key={`mixed-transfer-${sale.id || idx}`} className="eod-detail-row">
                      <div className="detail-left">
                        <span className="detail-customer">{sale.customer_name || 'Müşteri'}</span>
                        <span className="detail-meta">#{sale.store_sale_number || sale.id} • Karışık ödeme{bankAccount ? ` • ${bankAccount}` : ''}</span>
                      </div>
                      <span className="detail-amount">₺{transferAmount.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                    </div>
                  );
                })}
                {endOfDayReport.exchanges?.items?.filter(e => e.payment_method === 'Havale İade').map((exc, idx) => (
                  <div key={`exc-tr-${exc.id || idx}`} className="eod-detail-row">
                    <div className="detail-left">
                      <span className="detail-customer">{exc.customer_name || 'Müşteri'}</span>
                      <span className="detail-meta">Değişim İade #{exc.id} - Havale İade</span>
                    </div>
                    <span className="detail-amount" style={{ color: '#dc2626' }}>-₺{Math.abs(parseFloat(exc.difference) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                  </div>
                ))}
                {endOfDayReport.transfer.collectionTotal > 0 && (
                  <div className="eod-detail-row highlight-green">
                    <div className="detail-left"><span className="detail-customer">Havale/EFT Tahsilatlar</span></div>
                    <span className="detail-amount" style={{ color: '#16a34a' }}>+₺{endOfDayReport.transfer.collectionTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                  </div>
                )}
                {endOfDayReport.transfer.byAccount && Object.keys(endOfDayReport.transfer.byAccount).length > 0 && (
                  <div className="eod-detail-account-breakdown">
                    <div className="eod-detail-account-title">Hesap Dağılımı</div>
                    {Object.entries(endOfDayReport.transfer.byAccount).map(([accountName, data]) => (
                      <div key={accountName} className="eod-detail-row sub-row">
                        <span className="detail-customer">{stripBankAccountType(accountName)}</span>
                        <span className="detail-amount">₺{data.total.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                      </div>
                    ))}
                  </div>
                )}
                {(endOfDayReport.scrap?.transferTotal || 0) > 0 && (
                  <>
                    {endOfDayReport.scrap.items?.filter(s => {
                      const paidTransfer = parseFloat(s.paid_transfer) || 0;
                      if (paidTransfer > 0) return true;
                      return (s.payment_method === 'Havale' || s.payment_method === 'Havale/EFT') && paidTransfer === 0;
                    }).map((scrap, idx) => {
                      const amount = parseFloat(scrap.paid_transfer) > 0 ? parseFloat(scrap.paid_transfer) : parseFloat(scrap.total_amount || scrap.total_price || 0);
                      return (
                        <div key={`scrap-transfer-${scrap.id || idx}`} className="eod-detail-row">
                          <div className="detail-left">
                            <span className="detail-customer">{scrap.customer_name || 'Müşteri Yok'}</span>
                            <span className="detail-meta">⚖️ Hurda Alımı • {scrap.metal_type === 'gold' ? 'Altın' : 'Gümüş'} {scrap.purity} Ayar{scrap.bank_account_name ? ` • ${scrap.bank_account_name}` : ''}</span>
                          </div>
                          <span className="detail-amount" style={{ color: '#ef4444' }}>-₺{amount.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                        </div>
                      );
                    })}
                  </>
                )}
              </>
            )}

            {/* Açık Hesap */}
            {expandedPaymentType === 'openAccount' && (<>
              {endOfDayReport.openAccount.items?.map((sale, idx) => (
                <div key={sale.id || idx} className="eod-detail-row">
                  <div className="detail-left">
                    <span className="detail-customer">{sale.customer_name || 'Müşteri'}</span>
                    <span className="detail-meta">#{sale.store_sale_number || sale.id}</span>
                  </div>
                  <span className="detail-amount">₺{Number(sale.total).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                </div>
              ))}
              {/* Karışık ödemelerin Açık Hesap kısmı */}
              {endOfDayReport.mixed?.items?.map((sale, idx) => {
                let details = [];
                try { details = typeof sale.payment_details === 'string' ? JSON.parse(sale.payment_details) : (sale.payment_details || []); } catch(e) {}
                if (!Array.isArray(details)) return null;
                const openAccountAmount = details.filter(d => d.method && d.method.startsWith('Açık Hesap')).reduce((sum, d) => sum + (parseFloat(d.amount_tl || d.amountTL || d.amount) || 0), 0);
                if (openAccountAmount <= 0) return null;
                return (
                  <div key={`mixed-openaccount-${sale.id || idx}`} className="eod-detail-row">
                    <div className="detail-left">
                      <span className="detail-customer">{sale.customer_name || 'Müşteri'}</span>
                      <span className="detail-meta">#{sale.store_sale_number || sale.id} • Karışık ödeme</span>
                    </div>
                    <span className="detail-amount">₺{openAccountAmount.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                  </div>
                );
              })}
            </>)}

            {/* Sanal Pos */}
            {expandedPaymentType === 'sanalPos' && (<>
              {endOfDayReport.sanalPos.items?.map((sale, idx) => (
                <div key={sale.id || idx} className="eod-detail-row">
                  <div className="detail-left">
                    <span className="detail-customer">{sale.customer_name || 'Müşteri'}</span>
                    <span className="detail-meta">#{sale.store_sale_number || sale.id}{isShopifySale(sale) ? ` • ${formatPaymentMethod(sale)}` : ''}</span>
                  </div>
                  <span className="detail-amount">₺{Number(sale.total).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                </div>
              ))}
              {/* Karışık ödemelerin Sanal Pos kısmı */}
              {endOfDayReport.mixed?.items?.map((sale, idx) => {
                let details = [];
                try { details = typeof sale.payment_details === 'string' ? JSON.parse(sale.payment_details) : (sale.payment_details || []); } catch(e) {}
                if (!Array.isArray(details)) return null;
                const sanalPosAmount = details.filter(d => d.method === 'Sanal Pos').reduce((sum, d) => sum + (parseFloat(d.amount_tl || d.amountTL || d.amount) || 0), 0);
                if (sanalPosAmount <= 0) return null;
                return (
                  <div key={`mixed-sanalpos-${sale.id || idx}`} className="eod-detail-row">
                    <div className="detail-left">
                      <span className="detail-customer">{sale.customer_name || 'Müşteri'}</span>
                      <span className="detail-meta">#{sale.store_sale_number || sale.id} • Karışık ödeme</span>
                    </div>
                    <span className="detail-amount">₺{sanalPosAmount.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                  </div>
                );
              })}
            </>)}

            {/* Masraflar */}
            {expandedPaymentType === 'expenses' && endOfDayReport.expenses?.items?.map((expense, idx) => (
              <div key={expense.id || idx} className="eod-detail-row">
                <div className="detail-left">
                  <span className="detail-customer">{expense.description || 'Masraf'}</span>
                  <span className="detail-meta">
                    {expense.category || ''}{expense.payment_method ? ` • ${expense.payment_method}` : ''}
                  </span>
                </div>
                <span className="detail-amount" style={{ color: '#dc2626' }}>₺{Number(expense.amount || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
              </div>
            ))}

            {/* Hurda Alımı */}
            {expandedPaymentType === 'scrap' && endOfDayReport.scrap?.items?.map((scrap, idx) => (
              <div key={scrap.id || idx} className="eod-detail-row">
                <div className="detail-left">
                  <span className="detail-customer">{scrap.customer_name || 'Müşteri'}</span>
                  <span className="detail-meta">
                    {scrap.metal_type === 'gold' ? 'Altın' : 'Gümüş'} {scrap.purity} Ayar • {parseFloat(scrap.gross_weight || 0).toFixed(2)}gr
                  </span>
                </div>
                <span className="detail-amount" style={{ color: '#b45309' }}>₺{Number(scrap.total_price || scrap.total_amount || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
              </div>
            ))}
          </div>

          {/* Toplam */}
          <div className="eod-detail-footer">
            <span>
              {expandedPaymentType === 'ciro' && `Toplam (${(endOfDayReport.sales?.length || 0) + (endOfDayReport.exchanges?.items?.length || 0)} işlem)`}
              {expandedPaymentType === 'islem' && `Toplam ${endOfDayReport.totalSales + (endOfDayReport.exchanges?.count || 0)} işlem`}
              {expandedPaymentType === 'kasa' && 'Kasada Olması Gereken'}
              {expandedPaymentType === 'card' && `Net Kart (${endOfDayReport.card.count} satış${(endOfDayReport.cardRefund?.count || 0) + (endOfDayReport.exchanges?.items?.filter(e => e.payment_method === 'Kredi Kartı İade').length || 0) > 0 ? `, ${(endOfDayReport.cardRefund?.count || 0) + (endOfDayReport.exchanges?.items?.filter(e => e.payment_method === 'Kredi Kartı İade').length || 0)} iade` : ''})`}
              {expandedPaymentType === 'transfer' && `Net Havale/EFT${(endOfDayReport.scrap?.transferTotal || 0) > 0 ? ` (Satış: ₺${endOfDayReport.transfer.total.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} - Hurda: ₺${endOfDayReport.scrap.transferTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2 })})` : ''}`}
              {expandedPaymentType === 'openAccount' && `Toplam Açık Hesap (${endOfDayReport.openAccount.count} işlem)`}
              {expandedPaymentType === 'sanalPos' && `Toplam ${eTicaretCardLabel(endOfDayReport.sanalPos)} (${endOfDayReport.sanalPos.count} işlem)`}
              {expandedPaymentType === 'expenses' && `Toplam Masraf (${endOfDayReport.expenses?.count || 0} adet)`}
              {expandedPaymentType === 'scrap' && `Toplam Hurda Alımı (${endOfDayReport.scrap?.count || 0} adet) • ${((endOfDayReport.scrap?.goldGram || 0) + (endOfDayReport.scrap?.silverGram || 0)).toFixed(2)}gr`}
            </span>
            <strong style={expandedPaymentType === 'transfer' && (endOfDayReport.transfer.total - (endOfDayReport.scrap?.transferTotal || 0)) < 0 ? { color: '#ef4444' } : {}}>
              {(() => {
                const val = expandedPaymentType === 'ciro' ? endOfDayReport.grandTotal :
                  expandedPaymentType === 'islem' ? endOfDayReport.grandTotal :
                  expandedPaymentType === 'kasa' ? endOfDayReport.expectedCash :
                  expandedPaymentType === 'card' ? endOfDayReport.card.total :
                  expandedPaymentType === 'transfer' ? (endOfDayReport.transfer.total - (endOfDayReport.scrap?.transferTotal || 0)) :
                  expandedPaymentType === 'openAccount' ? endOfDayReport.openAccount.total :
                  expandedPaymentType === 'sanalPos' ? endOfDayReport.sanalPos.total :
                  expandedPaymentType === 'expenses' ? endOfDayReport.expenses?.total :
                  expandedPaymentType === 'scrap' ? (endOfDayReport.scrap?.netTotal ?? endOfDayReport.scrap?.total ?? 0) : 0;
                return `${val < 0 ? '-' : ''}₺${Math.abs(val).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}`;
              })()}
            </strong>
          </div>
        </div>
      ) : (
      <div className="eod-summary-cards">
        {/* Toplam Ciro */}
        <div className="eod-summary-card clickable" onClick={() => setExpandedPaymentType('ciro')}>
          <div className="card-icon teal"><Banknote size={20} /></div>
          <div className="card-value">₺{endOfDayReport.grandTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
          <div className="card-label">Toplam Ciro <ChevronDown size={14} /></div>
        </div>

        {/* İşlem Sayısı */}
        <div className="eod-summary-card clickable" onClick={() => setExpandedPaymentType('islem')}>
          <div className="card-icon blue"><ShoppingCart size={20} /></div>
          <div className="card-value">{endOfDayReport.totalSales + (endOfDayReport.exchanges?.count || 0)}</div>
          <div className="card-label">İşlem Sayısı <ChevronDown size={14} /></div>
        </div>

        {/* Nakit Kasa Toplamı */}
        <div className="eod-summary-card clickable" onClick={() => setExpandedPaymentType('kasa')}>
          <div className="card-icon green"><Banknote size={20} /></div>
          <div className="card-value">₺{endOfDayReport.expectedCash.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
          <div className="card-label">Nakit Kasa Toplamı <ChevronDown size={14} /></div>
        </div>

        {/* Kart Çekim */}
        {(endOfDayReport.card.count > 0 || endOfDayReport.card.total !== 0) && (
          <div className="eod-summary-card clickable" onClick={() => setExpandedPaymentType('card')}>
            <div className="card-icon purple"><CreditCard size={20} /></div>
            <div className="card-value">₺{endOfDayReport.card.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
            <div className="card-label">Kart Çekim ({endOfDayReport.card.count}) <ChevronDown size={14} /></div>
          </div>
        )}

        {/* Havale/EFT */}
        {(endOfDayReport.transfer.count > 0 || endOfDayReport.transfer.total !== 0 || (endOfDayReport.scrap?.transferTotal || 0) > 0) && (
          <div className="eod-summary-card clickable" onClick={() => setExpandedPaymentType('transfer')} style={{ minHeight: 'auto' }}>
            <div className="card-icon orange"><Send size={20} /></div>
            <div className="card-value" style={(endOfDayReport.transfer.total - (endOfDayReport.scrap?.transferTotal || 0)) < 0 ? { color: '#ef4444' } : {}}>
              {(endOfDayReport.transfer.total - (endOfDayReport.scrap?.transferTotal || 0)) < 0 ? '-' : ''}₺{Math.abs(endOfDayReport.transfer.total - (endOfDayReport.scrap?.transferTotal || 0)).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
            <div className="card-label">Havale/EFT ({endOfDayReport.transfer.count}{(endOfDayReport.scrap?.transferTotal || 0) > 0 ? ` - Hurda: ₺${endOfDayReport.scrap.transferTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}` : ''}) <ChevronDown size={14} /></div>
            {(() => {
              // Tüm kaynakları hesap bazlı birleştir
              const merged = {};
              if (endOfDayReport.transfer.byAccount) {
                Object.entries(endOfDayReport.transfer.byAccount).forEach(([name, data]) => {
                  if (!merged[name]) merged[name] = { total: 0 };
                  merged[name].total += data.total;
                });
              }
              if (endOfDayReport.transfer.collectionByAccount) {
                Object.entries(endOfDayReport.transfer.collectionByAccount).forEach(([name, data]) => {
                  if (!merged[name]) merged[name] = { total: 0 };
                  merged[name].total += data.total;
                });
              }
              if (endOfDayReport.scrap?.transferByAccount) {
                Object.entries(endOfDayReport.scrap.transferByAccount).forEach(([name, data]) => {
                  if (!merged[name]) merged[name] = { total: 0 };
                  merged[name].total -= data.total;
                });
              }
              // Hesap eşleşmeyen tahsilat/hurda fallback
              const hasCollectionAccounts = endOfDayReport.transfer.collectionByAccount && Object.keys(endOfDayReport.transfer.collectionByAccount).length > 0;
              const hasScrapAccounts = endOfDayReport.scrap?.transferByAccount && Object.keys(endOfDayReport.scrap.transferByAccount).length > 0;
              if (!hasCollectionAccounts && endOfDayReport.transfer.collectionTotal > 0) {
                if (!merged['Tahsilatlar']) merged['Tahsilatlar'] = { total: 0 };
                merged['Tahsilatlar'].total += endOfDayReport.transfer.collectionTotal;
              }
              if (!hasScrapAccounts && (endOfDayReport.scrap?.transferTotal || 0) > 0) {
                if (!merged['Hurda Alımı']) merged['Hurda Alımı'] = { total: 0 };
                merged['Hurda Alımı'].total -= endOfDayReport.scrap.transferTotal;
              }
              const entries = Object.entries(merged).filter(([, d]) => Math.abs(d.total) > 0.5);
              if (entries.length === 0) return null;
              return (
                <div style={{ width: '100%', marginTop: '6px', paddingTop: '6px', borderTop: '1px solid rgba(0,0,0,0.08)', display: 'flex', flexDirection: 'column', gap: '2px' }}>
                  {entries.map(([name, data]) => (
                    <div key={name} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.78rem', color: data.total < 0 ? '#ef4444' : '#64748b' }}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginRight: '8px' }}>{stripBankAccountType(name)}</span>
                      <span style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{data.total < 0 ? '-' : ''}₺{Math.abs(data.total).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</span>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
        )}

        {/* Açık Hesap */}
        {endOfDayReport.openAccount.total > 0 && (
          <div className="eod-summary-card clickable" onClick={() => setExpandedPaymentType('openAccount')}>
            <div className="card-icon red"><BookOpen size={20} /></div>
            <div className="card-value">₺{endOfDayReport.openAccount.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
            <div className="card-label">Açık Hesap ({endOfDayReport.openAccount.count}) <ChevronDown size={14} /></div>
          </div>
        )}

        {/* Sanal Pos */}
        {endOfDayReport.sanalPos.total > 0 && (
          <div className="eod-summary-card clickable" onClick={() => setExpandedPaymentType('sanalPos')}>
            <div className="card-icon cyan"><Smartphone size={20} /></div>
            <div className="card-value">₺{endOfDayReport.sanalPos.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
            <div className="card-label">{eTicaretCardLabel(endOfDayReport.sanalPos)} ({endOfDayReport.sanalPos.count}) <ChevronDown size={14} /></div>
          </div>
        )}

        {/* Toplam Masraf */}
        {endOfDayReport.expenses && endOfDayReport.expenses.total > 0 && (
          <div className="eod-summary-card clickable" onClick={() => setExpandedPaymentType('expenses')}>
            <div className="card-icon" style={{ backgroundColor: '#fee2e2', color: '#dc2626' }}><AlertTriangle size={20} /></div>
            <div className="card-value" style={{ color: '#dc2626' }}>₺{endOfDayReport.expenses.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
            <div className="card-label">Toplam Masraf ({endOfDayReport.expenses.count}) <ChevronDown size={14} /></div>
          </div>
        )}

        {/* Toplam Hurda Alımı */}
        {endOfDayReport.scrap && endOfDayReport.scrap.count > 0 && (
          <div className="eod-summary-card clickable" onClick={() => setExpandedPaymentType('scrap')}>
            <div className="card-icon" style={{ backgroundColor: '#fef3c7', color: '#b45309' }}><Scale size={20} /></div>
            <div className="card-value">{endOfDayReport.scrap.count} Adet</div>
            <div className="card-label" style={{ fontSize: '11px', color: '#92400e' }}>
              {((endOfDayReport.scrap.goldGrossGram || 0) + (endOfDayReport.scrap.silverGrossGram || 0)).toFixed(2)}gr brüt / {((endOfDayReport.scrap.goldNetGram ?? endOfDayReport.scrap.goldGrossGram ?? 0) + (endOfDayReport.scrap.silverNetGram ?? endOfDayReport.scrap.silverGrossGram ?? 0)).toFixed(2)}gr net
            </div>
            <div className="card-label">Toplam Hurda Alımı <ChevronDown size={14} /></div>
          </div>
        )}
      </div>
      )}

      {/* 2 Sütunlu Layout: Sol=Ödeme Dağılımı, Sağ=Kasiyer Raporu */}
      {!expandedPaymentType && <div className="eod-two-col">
        {/* SOL SÜTUN: Ödeme Dağılımı */}
        <div className="eod-col">
          <div className="eod-col-panel">
            <div className="eod-col-panel-header">
              <Wallet size={16} /> Ödeme Dağılımı
            </div>
            <div className="eod-col-panel-body">
              <div className="eod-payments" style={{ marginBottom: 0 }}>
                <div className="eod-section-title" style={{ margin: '0', padding: '10px 18px 6px', borderBottom: 'none' }}><Banknote size={14} style={{ marginRight: '5px', verticalAlign: 'middle' }} />Nakit</div>
                <div className="eod-payment-item" style={{ padding: '8px 18px' }}>
                  <span className="eod-payment-label">Toplam Nakit</span>
                  <span className="eod-payment-value">₺{endOfDayReport.cash.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
                {endOfDayReport.cash.usd > 0 && (
                  <div className="eod-payment-item sub-item" style={{ padding: '6px 18px 6px 32px' }}>
                    <span className="eod-payment-label">└ Dolar (USD)</span>
                    <span className="eod-payment-value">${endOfDayReport.cash.usd.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                )}
                {endOfDayReport.cash.eur > 0 && (
                  <div className="eod-payment-item sub-item" style={{ padding: '6px 18px 6px 32px' }}>
                    <span className="eod-payment-label">└ Euro (EUR)</span>
                    <span className="eod-payment-value">€{endOfDayReport.cash.eur.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                )}
                {endOfDayReport.cashRefund.count > 0 && (
                  <div className="eod-payment-item refund" style={{ padding: '8px 18px' }}>
                    <span className="eod-payment-label">Nakit İade</span>
                    <span className="eod-payment-value" style={{ color: '#ef4444' }}>-₺{endOfDayReport.cashRefund.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                )}
                {(endOfDayReport.scrapCashRefund?.count || 0) > 0 && (
                  <div className="eod-payment-item refund" style={{ padding: '8px 18px' }}>
                    <span className="eod-payment-label">Hurda Nakit İadesi</span>
                    <span className="eod-payment-value" style={{ color: '#ef4444' }}>-₺{endOfDayReport.scrapCashRefund.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                )}
                {(endOfDayReport.exchanges?.cashRefundTotal || 0) > 0 && (
                  <div className="eod-payment-item refund" style={{ padding: '8px 18px' }}>
                    <span className="eod-payment-label">Nakit Değişim İade</span>
                    <span className="eod-payment-value" style={{ color: '#ef4444' }}>-₺{endOfDayReport.exchanges.cashRefundTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                )}
                {(endOfDayReport.scrap?.cashTotal || 0) > 0 && (
                  <div className="eod-payment-item sub-item" style={{ padding: '6px 18px 6px 32px' }}>
                    <span className="eod-payment-label">└ Hurda Alımı (Nakit)</span>
                    <span className="eod-payment-value" style={{ color: '#ef4444' }}>-₺{endOfDayReport.scrap.cashTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                )}

                <div className="eod-section-title" style={{ margin: '0', padding: '10px 18px 6px', borderBottom: 'none' }}><CreditCard size={14} style={{ marginRight: '5px', verticalAlign: 'middle' }} />Kart & Transfer</div>
                <div className="eod-payment-item" style={{ padding: '8px 18px' }}>
                  <span className="eod-payment-label">Kredi Kartı</span>
                  <span className="eod-payment-value" style={endOfDayReport.card.total < 0 ? { color: '#ef4444' } : {}}>{endOfDayReport.card.total < 0 ? '-' : ''}₺{Math.abs(endOfDayReport.card.total).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
                <div className="eod-payment-item" style={{ padding: '8px 18px' }}>
                  <span className="eod-payment-label">Havale/EFT</span>
                  <span className="eod-payment-value" style={endOfDayReport.transfer.total < 0 ? { color: '#ef4444' } : {}}>{endOfDayReport.transfer.total < 0 ? '-' : ''}₺{Math.abs(endOfDayReport.transfer.total).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
                {(endOfDayReport.exchanges?.havaleRefundTotal || 0) > 0 && (
                  <div className="eod-payment-item sub-item" style={{ padding: '6px 18px 6px 32px' }}>
                    <span className="eod-payment-label">└ Havale Değişim İade</span>
                    <span className="eod-payment-value" style={{ color: '#ef4444' }}>-₺{endOfDayReport.exchanges.havaleRefundTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                )}
                {(endOfDayReport.scrap?.transferTotal || 0) > 0 && (
                  <div className="eod-payment-item sub-item" style={{ padding: '6px 18px 6px 32px' }}>
                    <span className="eod-payment-label">└ Hurda Alımı (Havale)</span>
                    <span className="eod-payment-value" style={{ color: '#ef4444' }}>-₺{endOfDayReport.scrap.transferTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                )}
                {endOfDayReport.transfer.byAccount && Object.keys(endOfDayReport.transfer.byAccount).length > 0 && (
                  Object.entries(endOfDayReport.transfer.byAccount).map(([accountName, data]) => (
                    <div key={accountName} className="eod-payment-item sub-item" style={{ padding: '6px 18px 6px 32px' }}>
                      <span className="eod-payment-label">└ {stripBankAccountType(accountName)}</span>
                      <span className="eod-payment-value">₺{data.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ({data.count})</span>
                    </div>
                  ))
                )}
                {endOfDayReport.openAccount.count > 0 && (
                  <div className="eod-payment-item" style={{ padding: '8px 18px' }}>
                    <span className="eod-payment-label">Veresiye</span>
                    <span className="eod-payment-value">₺{endOfDayReport.openAccount.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                )}
                {endOfDayReport.mixed.count > 0 && (
                  <div className="eod-payment-item" style={{ padding: '8px 18px' }}>
                    <span className="eod-payment-label">Karma Ödeme</span>
                    <span className="eod-payment-value">₺{endOfDayReport.mixed.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                )}
                {endOfDayReport.voucher.count > 0 && (
                  <div className="eod-payment-item" style={{ padding: '8px 18px' }}>
                    <span className="eod-payment-label">Bakiye</span>
                    <span className="eod-payment-value">₺{endOfDayReport.voucher.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                )}

                {endOfDayReport.repairRevenue && endOfDayReport.repairRevenue.total > 0 && (
                  <>
                    <div className="eod-section-title" style={{ margin: '0', padding: '10px 18px 6px', borderBottom: 'none' }}><Wrench size={14} style={{ marginRight: '5px', verticalAlign: 'middle' }} />Tamirat Geliri</div>
                    <div className="eod-payment-item" style={{ padding: '8px 18px' }}>
                      <span className="eod-payment-label">Tamirat Toplam ({endOfDayReport.repairRevenue.count})</span>
                      <span className="eod-payment-value" style={{ color: '#059669' }}>₺{endOfDayReport.repairRevenue.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                    {endOfDayReport.repairRevenue.cashTotal > 0 && (
                      <div className="eod-payment-item sub-item" style={{ padding: '6px 18px 6px 32px' }}>
                        <span className="eod-payment-label">└ Nakit</span>
                        <span className="eod-payment-value">₺{endOfDayReport.repairRevenue.cashTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                      </div>
                    )}
                    {endOfDayReport.repairRevenue.cardTotal > 0 && (
                      <div className="eod-payment-item sub-item" style={{ padding: '6px 18px 6px 32px' }}>
                        <span className="eod-payment-label">└ Kredi Kartı</span>
                        <span className="eod-payment-value">₺{endOfDayReport.repairRevenue.cardTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                      </div>
                    )}
                    {endOfDayReport.repairRevenue.transferTotal > 0 && (
                      <div className="eod-payment-item sub-item" style={{ padding: '6px 18px 6px 32px' }}>
                        <span className="eod-payment-label">└ Havale/EFT</span>
                        <span className="eod-payment-value">₺{endOfDayReport.repairRevenue.transferTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                      </div>
                    )}
                  </>
                )}

                {endOfDayReport.scrap && endOfDayReport.scrap.count > 0 && (
                  <>
                    <div className="eod-section-title" style={{ margin: '0', padding: '10px 18px 6px', borderBottom: 'none' }}><Scale size={14} style={{ marginRight: '5px', verticalAlign: 'middle' }} />Hurda Alımları</div>
                    <div className="eod-payment-item" style={{ padding: '8px 18px' }}>
                      <span className="eod-payment-label">Hurda Toplam ({endOfDayReport.scrap.count} adet)</span>
                      <span className="eod-payment-value" style={{ color: '#b45309' }}>₺{(endOfDayReport.scrap.netTotal ?? endOfDayReport.scrap.total).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                    {endOfDayReport.scrap.goldCount > 0 && (
                      <div className="eod-payment-item sub-item" style={{ padding: '6px 18px 6px 32px' }}>
                        <span className="eod-payment-label">└ Altın ({endOfDayReport.scrap.goldCount})</span>
                        <span className="eod-payment-value">₺{endOfDayReport.scrap.goldTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ({endOfDayReport.scrap.goldGrossGram?.toFixed(2)}gr)</span>
                      </div>
                    )}
                    {endOfDayReport.scrap.silverCount > 0 && (
                      <div className="eod-payment-item sub-item" style={{ padding: '6px 18px 6px 32px' }}>
                        <span className="eod-payment-label">└ Gümüş ({endOfDayReport.scrap.silverCount})</span>
                        <span className="eod-payment-value">₺{endOfDayReport.scrap.silverTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ({endOfDayReport.scrap.silverGrossGram?.toFixed(2)}gr)</span>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* SAĞ SÜTUN: Kasiyer Raporu */}
        <div className="eod-col">
          {/* En Çok Satan Kasiyer */}
          {endOfDayReport.topCashier && (
            <div className="eod-cashier-section" style={{ marginBottom: '14px' }}>
              <div className="eod-cashier-header" onClick={() => setExpandedCashiers(prev => ({ ...prev, [endOfDayReport.topCashier.name]: !prev[endOfDayReport.topCashier.name] }))} style={{ cursor: 'pointer' }}>
                <div className="cashier-left">
                  <div className="cashier-icon" style={{ marginRight: '8px', width: '42px', height: '42px', background: '#0f766e', color: '#fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Medal size={20} /></div>
                  <div className="cashier-meta">
                    <div className="cashier-name">{endOfDayReport.topCashier.name}</div>
                    <div className="cashier-stats">{endOfDayReport.topCashier.salesCount} satış{[endOfDayReport.topCashier.cash > 0 && ` | N:₺${endOfDayReport.topCashier.cash.toLocaleString('tr-TR', { maximumFractionDigits: 0 })}`, endOfDayReport.topCashier.card > 0 && ` K:₺${endOfDayReport.topCashier.card.toLocaleString('tr-TR', { maximumFractionDigits: 0 })}`, endOfDayReport.topCashier.transfer > 0 && ` H:₺${endOfDayReport.topCashier.transfer.toLocaleString('tr-TR', { maximumFractionDigits: 0 })}`].filter(Boolean).join('')}</div>
                  </div>
                </div>
                <div className="cashier-right">
                  <span className="cashier-total">₺{endOfDayReport.topCashier.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  <ChevronDown size={16} className={`chevron ${expandedCashiers[endOfDayReport.topCashier.name] ? 'open' : ''}`} />
                </div>
              </div>
              {expandedCashiers[endOfDayReport.topCashier.name] && (
                <div className="eod-cashier-body">
                  {endOfDayReport.topCashier.sales.map(sale => {
                    const displayAmt = sale.sale_type === 'exchange_return' ? Number(sale.total) : getSaleDisplayAmount(sale);
                    return (
                    <div key={sale.id} className="cashier-sale-row">
                      <div className="sale-info">
                        <span className="sale-time">{new Date(sale.created_at).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}</span>
                        <span>{sale.customer_name || '-'}</span>
                        <span className="sale-method">{sale.sale_type === 'exchange_return' ? 'Değişim İade' : formatPaymentMethod(sale)}</span>
                      </div>
                      <span className="sale-amount" style={displayAmt < 0 ? { color: '#dc2626' } : {}}>
                        {displayAmt < 0 ? '-' : ''}₺{Math.abs(displayAmt).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </span>
                    </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* Kasiyer Bazlı Rapor */}
          {endOfDayReport.cashierList && endOfDayReport.cashierList.length > 0 && (
            <>
              {endOfDayReport.cashierList.filter(c => !endOfDayReport.topCashier || c.name !== endOfDayReport.topCashier.name).map((cashier, idx) => (
                <div key={idx} className="eod-cashier-section">
                  <div className="eod-cashier-header" onClick={() => setExpandedCashiers(prev => ({ ...prev, [cashier.name]: !prev[cashier.name] }))}>
                    <div className="cashier-left">
                      <div className="cashier-avatar">{cashier.name.charAt(0).toUpperCase()}</div>
                      <div className="cashier-meta">
                        <div className="cashier-name">{cashier.name}</div>
                        <div className="cashier-stats">{cashier.salesCount} satış{[cashier.cash > 0 && ` | N:₺${cashier.cash.toLocaleString('tr-TR', { maximumFractionDigits: 0 })}`, cashier.card > 0 && ` K:₺${cashier.card.toLocaleString('tr-TR', { maximumFractionDigits: 0 })}`, cashier.transfer > 0 && ` H:₺${cashier.transfer.toLocaleString('tr-TR', { maximumFractionDigits: 0 })}`].filter(Boolean).join('')}</div>
                      </div>
                    </div>
                    <div className="cashier-right">
                      <span className="cashier-total">₺{cashier.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                      <ChevronDown size={16} className={`chevron ${expandedCashiers[cashier.name] ? 'open' : ''}`} />
                    </div>
                  </div>
                  {expandedCashiers[cashier.name] && (
                    <div className="eod-cashier-body">
                      {cashier.sales.map(sale => {
                        const displayAmt = sale.sale_type === 'exchange_return' ? Number(sale.total) : getSaleDisplayAmount(sale);
                        return (
                        <div key={sale.id} className="cashier-sale-row">
                          <div className="sale-info">
                            <span className="sale-time">{new Date(sale.created_at).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}</span>
                            <span>{sale.customer_name || '-'}</span>
                            <span className="sale-method">{sale.sale_type === 'exchange_return' ? 'Değişim İade' : formatPaymentMethod(sale)}</span>
                          </div>
                          <span className="sale-amount" style={displayAmt < 0 ? { color: '#dc2626' } : {}}>
                            {displayAmt < 0 ? '-' : ''}₺{Math.abs(displayAmt).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </span>
                        </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
      </div>}

      {!expandedPaymentType && <>
      {/* Hurda Alımları Tablosu */}
      {endOfDayReport.scrap && endOfDayReport.scrap.count > 0 && (
        <>
          <div className="eod-section-title"><Scale size={16} style={{ marginRight: '6px', verticalAlign: 'middle' }} />Hurda Alımları ({endOfDayReport.scrap.count})</div>
          <div className="eod-products-table-wrapper" style={{ maxHeight: '250px' }}>
            <table className="eod-products-table">
              <thead>
                <tr>
                  <th>Müşteri</th>
                  <th>Metal</th>
                  <th>Ayar</th>
                  <th>Brüt (gr)</th>
                  <th>Has (gr)</th>
                  <th>Net (gr)</th>
                  <th>Alış Kuru</th>
                  <th>Ödeme</th>
                  <th>Tutar</th>
                </tr>
              </thead>
              <tbody>
                {endOfDayReport.scrap.items.map(scrap => (
                  <tr key={scrap.id}>
                    <td style={{ fontWeight: 500 }}>{scrap.customer_name || 'Müşteri'}</td>
                    <td>{scrap.metal_type === 'gold' ? 'Altın' : 'Gümüş'}</td>
                    <td>{scrap.purity || '-'}</td>
                    <td>{parseFloat(scrap.gross_weight || 0).toFixed(2)}</td>
                    <td>{parseFloat(scrap.pure_weight || 0).toFixed(2)}</td>
                    <td>{((parseFloat(scrap.gross_weight) || 0) - (parseFloat(scrap.waste_gram) || 0)).toFixed(2)}</td>
                    <td>₺{(parseFloat(scrap.unit_price) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    <td style={{ color: '#64748b', fontSize: '0.82rem' }}>{scrap.payment_method === 'Havale' && scrap.bank_account_name ? scrap.bank_account_name : (scrap.payment_method || 'Nakit')}</td>
                    <td style={{ fontWeight: 600, color: '#ef4444' }}>-₺{(parseFloat(scrap.total_amount) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  </tr>
                ))}
                {endOfDayReport.scrap.refundItems?.map((refItem, idx) => (
                  <tr key={`scrap-refund-${idx}`}>
                    <td style={{ fontWeight: 500 }}>{refItem.customer_name}</td>
                    <td colSpan={6} style={{ fontSize: '0.82rem' }}>Hurda İade (Fiş #{refItem.receipt_number})</td>
                    <td style={{ color: '#64748b', fontSize: '0.82rem' }}>İade</td>
                    <td style={{ fontWeight: 600, color: '#16a34a' }}>+₺{refItem.amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  </tr>
                ))}
                <tr className="eod-cashier-total-row">
                  <td colSpan={8} style={{ textAlign: 'right', fontWeight: 700, fontSize: '0.82rem', color: '#334155' }}>Toplam:</td>
                  <td style={{ fontWeight: 700, color: endOfDayReport.scrap.netTotal > 0 ? '#ef4444' : '#334155', fontSize: '0.85rem' }}>-₺{(endOfDayReport.scrap.netTotal ?? endOfDayReport.scrap.total).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Tahsilatlar Tablosu */}
      {endOfDayReport.collections && endOfDayReport.collections.count > 0 && (
        <>
          <div className="eod-section-title"><Coins size={16} style={{ marginRight: '6px', verticalAlign: 'middle' }} />Tahsilatlar ({endOfDayReport.collections.count})</div>
          <div className="eod-products-table-wrapper" style={{ maxHeight: '250px' }}>
            <table className="eod-products-table">
              <thead>
                <tr>
                  <th>Müşteri</th>
                  <th>Ödeme Yöntemi</th>
                  <th>Tutar</th>
                </tr>
              </thead>
              <tbody>
                {endOfDayReport.collections.items.map(col => (
                  <tr key={col.id}>
                    <td style={{ fontWeight: 500 }}>{col.customer_name || 'Müşteri'}</td>
                    <td style={{ color: '#64748b', fontSize: '0.82rem' }}>{col.payment_method || 'Nakit'}</td>
                    <td style={{ fontWeight: 600, color: '#059669' }}>₺{(parseFloat(col.amount) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  </tr>
                ))}
                <tr className="eod-cashier-total-row">
                  <td colSpan={2} style={{ textAlign: 'right', fontWeight: 700, fontSize: '0.82rem', color: '#334155' }}>Toplam:</td>
                  <td style={{ fontWeight: 700, color: '#059669', fontSize: '0.85rem' }}>₺{endOfDayReport.collections.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Tüm İşlemler Tablosu - Birleşik Tablo */}
      {endOfDayReport.allProducts && endOfDayReport.allProducts.length > 0 && (
        <>
          <div className="eod-section-title"><Package size={16} style={{ marginRight: '6px', verticalAlign: 'middle' }} />Tüm İşlemler ({eodCashierFilter.length > 0 ? endOfDayReport.allProducts.filter(p => eodCashierFilter.includes(p.cashier)).length + '/' : ''}{endOfDayReport.allProducts.length} ürün)</div>
          {/* Kasiyer Filtreleri */}
          <div className="eod-cashier-filters">
            <button
              className={`eod-cashier-filter-btn ${eodCashierFilter.length === 0 ? 'active' : ''}`}
              onClick={() => setEodCashierFilter([])}
            >Tümü</button>
            {[...new Set(endOfDayReport.allProducts.map(p => p.cashier))].sort((a, b) => a.localeCompare(b, 'tr')).map(cashier => (
              <button
                key={cashier}
                className={`eod-cashier-filter-btn ${eodCashierFilter.includes(cashier) ? 'active' : ''}`}
                onClick={() => setEodCashierFilter(prev =>
                  prev.includes(cashier) ? prev.filter(c => c !== cashier) : [...prev, cashier]
                )}
              >{cashier}</button>
            ))}
          </div>
          <div className="eod-products-table-wrapper">
            <table className="eod-products-table eod-unified-table">
              <thead>
                <tr>
                  <th>Kasiyer</th>
                  <th>Fiş No</th>
                  <th>Saat</th>
                  <th>Tür</th>
                  <th>Ürün Adı</th>
                  <th>Barkod</th>
                  <th>Gramaj</th>
                  <th>Adet</th>
                  <th>Birim Fiyat</th>
                  <th>İndirim</th>
                  <th>Toplam</th>
                  <th>İade</th>
                  <th>Müşteri</th>
                  <th>Ödeme</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  const rows = [];
                  let lastCashier = '';
                  const allProds = endOfDayReport.allProducts;
                  const products = eodCashierFilter.length > 0 ? allProds.filter(p => eodCashierFilter.includes(p.cashier)) : allProds;

                  // Fiş bazlı gruplama
                  const receiptGroups = [];
                  const receiptMap = {};
                  products.forEach(product => {
                    const key = product.saleId || product.receiptNumber;
                    if (!receiptMap[key]) {
                      receiptMap[key] = { key, items: [], cashier: product.cashier };
                      receiptGroups.push(receiptMap[key]);
                    }
                    receiptMap[key].items.push(product);
                  });

                  receiptGroups.forEach((group, gIdx) => {
                    const isNewCashier = group.cashier !== lastCashier;
                    lastCashier = group.cashier;
                    const nextGroup = receiptGroups[gIdx + 1];
                    const isLastOfCashier = !nextGroup || nextGroup.cashier !== group.cashier;
                    const rKey = `r_${group.key}`;
                    const isOpen = expandedSales[rKey];
                    const firstItem = group.items[0];
                    const groupTotal = group.items.reduce((s, p) => s + p.total, 0);
                    const groupDiscount = group.items.reduce((s, p) => s + (p.discount || 0), 0);
                    const groupQty = group.items.reduce((s, p) => s + (p.quantity || 0), 0);
                    const isSale = firstItem.type === 'Satış' || firstItem.type === 'Fark/Tamirat';
                    const toggleOpen = () => setExpandedSales(prev => ({ ...prev, [rKey]: !prev[rKey] }));

                    // Fiş özet satırı (her zaman gösterilir)
                    rows.push(
                      <tr key={`r-${gIdx}`}
                        className={`eod-receipt-row ${isNewCashier && gIdx > 0 ? 'eod-cashier-divider' : ''} ${isOpen ? 'eod-receipt-open' : ''}`}
                        onClick={toggleOpen}
                        style={{ cursor: 'pointer' }}>
                        <td style={{ fontWeight: 500 }}>{isNewCashier ? firstItem.cashier : ''}</td>
                        <td style={{ color: '#6366f1', fontSize: '0.78rem', fontFamily: 'monospace' }}>{firstItem.receiptNumber || '-'}</td>
                        <td style={{ color: '#0f766e', fontWeight: 500, fontSize: '0.82rem' }}>{firstItem.time ? new Date(firstItem.time).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }) : '-'}</td>
                        <td>
                          <span style={{ fontSize: '0.75rem', fontWeight: 600, padding: '2px 8px', borderRadius: '10px', backgroundColor: firstItem.type === 'Satış' ? '#ecfdf5' : firstItem.type === 'İade' ? '#fef2f2' : '#fffbeb', color: firstItem.type === 'Satış' ? '#059669' : firstItem.type === 'İade' ? '#ef4444' : '#f59e0b' }}>{firstItem.type}</span>
                        </td>
                        <td>
                          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                            <ChevronDown size={13} style={{ color: '#94a3b8', transition: 'transform 0.2s', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink: 0 }} />
                            <span style={{ fontWeight: 500 }}>{group.items.length > 1 ? `${group.items.length} ürün` : firstItem.name}</span>
                          </span>
                        </td>
                        <td className="product-barcode">{group.items.length === 1 ? firstItem.barcode : ''}</td>
                        <td style={{ color: '#7c3aed', fontSize: '0.82rem', fontWeight: 500 }}>{group.items.length === 1 && firstItem.weight ? `${parseFloat(firstItem.weight).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} gr` : '-'}</td>
                        <td>{groupQty}</td>
                        <td>{group.items.length === 1 ? `₺${firstItem.unitPrice.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : ''}</td>
                        <td style={{ color: groupDiscount > 0 ? '#ef4444' : '#94a3b8', fontSize: '0.82rem' }}>
                          {groupDiscount > 0 ? `-₺${groupDiscount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-'}
                        </td>
                        <td style={{ fontWeight: 600 }}>{isSale ? `₺${groupTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-'}</td>
                        <td style={{ fontWeight: 600, color: '#ef4444' }}>{!isSale ? `-₺${groupTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-'}</td>
                        <td>{firstItem.customerName !== '-' ? firstItem.customerName : ''}</td>
                        <td>
                          {firstItem.sale && firstItem.sale.payment_method === 'Karışık' && firstItem.sale.payment_details ? (
                            <span className="eod-mixed-payment-wrapper"
                              onMouseEnter={(e) => {
                                const tooltip = e.currentTarget.querySelector('.eod-mixed-payment-tooltip');
                                if (tooltip) {
                                  const rect = e.currentTarget.getBoundingClientRect();
                                  tooltip.style.left = rect.left + 'px';
                                  tooltip.style.top = (rect.top - tooltip.offsetHeight - 8) + 'px';
                                  if (rect.top - tooltip.offsetHeight - 8 < 10) {
                                    tooltip.style.top = (rect.bottom + 8) + 'px';
                                  }
                                }
                              }}
                            >
                              <span style={{ fontSize: '0.8rem', color: '#64748b', borderBottom: '1px dashed #94a3b8', cursor: 'help' }}>{formatPaymentMethod(firstItem.sale)}</span>
                              <div className="eod-mixed-payment-tooltip">
                                {(() => { try { const details = typeof firstItem.sale.payment_details === 'string' ? JSON.parse(firstItem.sale.payment_details) : firstItem.sale.payment_details; if (Array.isArray(details)) { return details.map((d, i) => (<div key={i} className="tooltip-row"><span>{d.method}{d.currency && d.currency !== 'TRY' ? ` (${d.currency})` : ''}{d.bank_account ? ` - ${stripBankAccountType(d.bank_account)}` : ''}</span><span style={{ fontWeight: 600 }}>₺{Number(d.amount_tl || d.amount || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>)); } } catch (e) {} return null; })()}
                              </div>
                            </span>
                          ) : (
                            <span style={{ fontSize: '0.8rem', color: '#64748b' }}>{firstItem.sale ? formatPaymentMethod(firstItem.sale) : firstItem.paymentMethod}</span>
                          )}
                        </td>
                      </tr>
                    );

                    // Detay satırları (açıksa)
                    if (isOpen) {
                      group.items.forEach((product, pIdx) => {
                        rows.push(
                          <tr key={`r-${gIdx}-${pIdx}`} className="eod-receipt-detail-row">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td style={{ paddingLeft: '26px', color: '#475569' }}>{product.name}</td>
                            <td className="product-barcode">{product.barcode}</td>
                            <td style={{ color: '#7c3aed', fontSize: '0.82rem', fontWeight: 500 }}>{product.weight ? `${parseFloat(product.weight).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} gr` : '-'}</td>
                            <td>{product.quantity}</td>
                            <td>₺{product.unitPrice.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td style={{ color: product.discount > 0 ? '#ef4444' : '#94a3b8', fontSize: '0.82rem' }}>
                              {product.discount > 0 ? `-₺${product.discount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-'}
                            </td>
                            <td style={{ fontWeight: 500 }}>{isSale ? `₺${product.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-'}</td>
                            <td style={{ fontWeight: 500, color: '#ef4444' }}>{!isSale ? `-₺${product.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-'}</td>
                            <td></td>
                            <td></td>
                          </tr>
                        );
                      });
                    }

                    // Kasiyerin son grubundan sonra toplam satırı
                    if (isLastOfCashier) {
                      const cashierProducts = products.filter(p => p.cashier === group.cashier);
                      const cashierSalesTotal = cashierProducts.filter(p => p.type === 'Satış' || p.type === 'Fark/Tamirat').reduce((s, p) => s + p.total, 0);
                      const cashierReturnsTotal = cashierProducts.filter(p => p.type !== 'Satış' && p.type !== 'Fark/Tamirat').reduce((s, p) => s + p.total, 0);
                      const cashierWeight = cashierProducts.reduce((s, p) => s + (parseFloat(p.weight) || 0), 0);
                      const cashierQty = cashierProducts.reduce((s, p) => s + (p.quantity || 0), 0);
                      const cashierUnitPrice = cashierProducts.reduce((s, p) => s + (p.unitPrice || 0), 0);
                      const cashierDiscount = cashierProducts.reduce((s, p) => s + (p.discount || 0), 0);
                      const tStyle = { fontWeight: 700, fontSize: '0.85rem', padding: '6px 10px' };
                      rows.push(
                        <tr key={`total-${group.cashier}`} className="eod-cashier-total-row">
                          <td colSpan={6} style={{ textAlign: 'right', fontWeight: 700, fontSize: '0.82rem', color: '#334155', padding: '6px 10px' }}>
                            {group.cashier} Toplam:
                          </td>
                          <td style={{ ...tStyle, color: '#7c3aed' }}>{cashierWeight > 0 ? `${cashierWeight.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} gr` : '-'}</td>
                          <td style={{ ...tStyle, color: '#334155' }}>{cashierQty}</td>
                          <td style={{ ...tStyle, color: '#334155' }}>₺{cashierUnitPrice.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                          <td style={{ ...tStyle, color: cashierDiscount > 0 ? '#ef4444' : '#94a3b8' }}>{cashierDiscount > 0 ? `-₺${cashierDiscount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-'}</td>
                          <td style={{ ...tStyle, color: '#059669' }}>₺{cashierSalesTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                          <td style={{ ...tStyle, color: cashierReturnsTotal > 0 ? '#ef4444' : '#94a3b8' }}>{cashierReturnsTotal > 0 ? `-₺${cashierReturnsTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-'}</td>
                          <td colSpan={2}></td>
                        </tr>
                      );
                    }
                  });
                  return rows;
                })()}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Tamirat Gelirleri Tablosu */}
      {endOfDayReport.repairRevenue && endOfDayReport.repairRevenue.count > 0 && (
        <>
          <div className="eod-section-title"><Wrench size={16} style={{ marginRight: '6px', verticalAlign: 'middle' }} />Tamirat Gelirleri ({endOfDayReport.repairRevenue.count})</div>
          <div className="eod-products-table-wrapper" style={{ maxHeight: '250px' }}>
            <table className="eod-products-table">
              <thead>
                <tr>
                  <th>Müşteri</th>
                  <th>Fiş No</th>
                  <th>Açıklama</th>
                  <th>Ödeme Yöntemi</th>
                  <th>Tutar</th>
                </tr>
              </thead>
              <tbody>
                {endOfDayReport.repairRevenue.items.map(repair => (
                  <tr key={repair.is_deposit ? `dep-${repair.id}` : `pay-${repair.id}`}>
                    <td style={{ fontWeight: 500 }}>{repair.customer_name || 'Müşteri'}</td>
                    <td style={{ color: '#6366f1', fontSize: '0.82rem', fontFamily: 'monospace' }}>{repair.repair_code || '-'}</td>
                    <td style={{ fontSize: '0.82rem', color: '#64748b' }}>{repair.item_description || '-'}</td>
                    <td style={{ color: '#64748b', fontSize: '0.82rem' }}>{repair.payment_method || 'Nakit'}</td>
                    <td style={{ fontWeight: 600, color: '#059669' }}>₺{Number(repair.payment_amount).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  </tr>
                ))}
                <tr className="eod-cashier-total-row">
                  <td colSpan={4} style={{ textAlign: 'right', fontWeight: 700, fontSize: '0.82rem', color: '#334155' }}>Toplam:</td>
                  <td style={{ fontWeight: 700, color: '#059669', fontSize: '0.85rem' }}>₺{endOfDayReport.repairRevenue.total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
      </>}
    </>
);

export default EndOfDayGenel;
